export const environment = {
  production: true,
  urlUsuarios: 'https://z1domujff4.execute-api.us-east-1.amazonaws.com/pre/desbloqueoCuenta',
  urlApiDesbloqueo: 'https://z1domujff4.execute-api.us-east-1.amazonaws.com/pre/desbloqueoCuenta',
  siteKey: '6LfrWmInAAAAAEWW68gdhAnS89F68TaKyF8ihLD5',
  /*urlUsuarios: 'https://d3pkipc8wz3smh.cloudfront.net/desbloqueoCuenta',
  urlApiDesbloqueo: 'https://d3pkipc8wz3smh.cloudfront.net/desbloqueoCuenta',
  siteKey: 'k7MBkv2rbj2g3hqgctTlX9v2PyDlpNoc3K1crWhe',*/
  version:'v.d.0.18',
  apikey:'bJ1rHK1q3B6zptcwPpxE96CJE9shzmXoaPz78hHb'
};
